import { render, staticRenderFns } from "./AddEmployeeModalNew.vue?vue&type=template&id=0622e7e4"
import script from "./AddEmployeeModalNew.vue?vue&type=script&lang=ts"
export * from "./AddEmployeeModalNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0622e7e4')) {
      api.createRecord('0622e7e4', component.options)
    } else {
      api.reload('0622e7e4', component.options)
    }
    module.hot.accept("./AddEmployeeModalNew.vue?vue&type=template&id=0622e7e4", function () {
      api.rerender('0622e7e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AddEmployeeModalNew.vue"
export default component.exports